import { render, staticRenderFns } from "./largeScreenManagementListB.vue?vue&type=template&id=3679d15e"
import script from "./largeScreenManagementListB.vue?vue&type=script&lang=js"
export * from "./largeScreenManagementListB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports